import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-alumni-bpharm',
  templateUrl: './alumni-bpharm.component.html',
  styleUrls: ['./alumni-bpharm.component.css']
})
export class AlumniBpharmComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

  banner: any = {
    pagetitle: "Alumni B-Pharm",
    bg_image: "assets/images/banner/bnr3.jpg",
    title: "Alumni B-Pharm",
  }
}
